import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';

export function useMyTimeOffSummary(enabled = true) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: TIME_OFF_KEYS.mySummary(orgId),
    queryFn: ({ signal }) => timeOffService.getMySummary(signal),
    staleTime: 60_000,
    enabled: !!orgId && enabled,
  });
}
